export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "dasha_phal": "ದಶಾ ಫಲವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "planetary_periods_analysis": "ಗ್ರಹ ಅವಧಿಗಳ ವಿಶ್ಲೇಷಣೆ",
    "dasha_phal_description": "ನಿಮ್ಮ ವಿಂಶೋತ್ತರಿ ಮಹಾದಶೆಯ ಪ್ರಯಾಣವು ವಿಶೇಷವಾಗಿ ಶುಕ್ರ, ಸೂರ್ಯ, ಚಂದ್ರ, ಮಂಗಳ, ರಾಹು ಮತ್ತು ಶನಿ ಅವಧಿಗಳಲ್ಲಿ ಬಲವಾದ ವೃತ್ತಿ ಬೆಳವಣಿಗೆ, ಸಂಪತ್ತು, ಮಾನ್ಯತೆ ಮತ್ತು ಸಹಾಯಕ ಸಂಬಂಧಗಳ ಹಂತಗಳನ್ನು ತೋರಿಸುತ್ತದೆ.",

    // Service Information
    "enter_birth_details": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_dasha_phal_analysis": "ಸಂಪೂರ್ಣ ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_dasha_analysis_note": "ನಿಮ್ಮ ಜೀವನದ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುವ ಎಲ್ಲಾ ಪ್ರಮುಖ ಮತ್ತು ಸಣ್ಣ ಗ್ರಹ ಅವಧಿಗಳ ಸಮಗ್ರ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_dasha": "ನಿಖರವಾದ ದಶಾ ಲೆಕ್ಕಾಚಾರಗಳಿಗಾಗಿ ನಿಖರವಾದ ಜನ್ಮ ಸಮಯ ಅತ್ಯಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Features & Benefits
    "current_dasha_period_analysis": "ಪ್ರಸ್ತುತ ದಶಾ ಅವಧಿ ವಿಶ್ಲೇಷಣೆ",
    "planetary_influence_detailed": "ವಿಸ್ತೃತ ಗ್ರಹ ಪ್ರಭಾವ",
    "future_dasha_predictions": "ಭವಿಷ್ಯದ ದಶಾ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "career_and_finance_guidance": "ವೃತ್ತಿ ಮತ್ತು ಹಣಕಾಸು ಮಾರ್ಗದರ್ಶನ",
    "remedial_measures": "ಪರಿಹಾರಾತ್ಮಕ ಕ್ರಮಗಳು",
    "pdf_download": "PDF ಡೌನ್‌ಲೋಡ್",

    "what_you_get": "ನೀವು ಏನು ಪಡೆಯುತ್ತೀರಿ",
    "current_mahadasha_antardasha": "ಪ್ರಸ್ತುತ ಮಹಾದಶೆ ಮತ್ತು ಅಂತರ್ದಶೆ",
    "planetary_effects_detailed": "ವಿಸ್ತೃತ ಗ್ರಹ ಪರಿಣಾಮಗಳು",
    "timing_of_events": "ಪ್ರಮುಖ ಘಟನೆಗಳ ಸಮಯ",
    "future_dasha_timeline": "ಭವಿಷ್ಯದ ದಶಾ ಸಮಯಸೂಚಿ",

    // Actions & Buttons
    "pay_and_generate_chart": "ಪಾವತಿ ಮಾಡಿ ಮತ್ತು ವಿಶ್ಲೇಷಣೆ ರಚಿಸಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿನಂತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "dasha_phal_analysis_processing": "ನಿಮ್ಮ ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ ವಿನಂತಿಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ ಮತ್ತು ನಮ್ಮ ಪರಿಣಿತ ಜ್ಯೋತಿಷಿಗಳಿಂದ ಸಂಸ್ಕರಿಸಲಾಗುತ್ತಿದೆ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿತರಣಾ ಸಮಯ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ೧೨ ಗಂಟೆಗಳೊಳಗೆ ವಿತರಿಸಲಾಗುವುದು",
    "whatsapp_notification": "WhatsApp ಅಧಿಸೂಚನೆ",
    "whatsapp_delivery_note": "ನೀವು WhatsApp ನಲ್ಲಿ ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ಕಳುಹಿಸಲಾಗುವುದು",

    // What You'll Receive
    "what_youll_receive": "ನೀವು ಏನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ",
    "detailed_dasha_phal_report": "ವಿಸ್ತೃತ ದಶಾ ಫಲ ವರದಿ (PDF)",
    "current_planetary_periods": "ಪ್ರಸ್ತುತ ಗ್ರಹ ಅವಧಿಗಳ ವಿಶ್ಲೇಷಣೆ",
    "future_dasha_predictions_timeline": "ಭವಿಷ್ಯದ ದಶಾ ಭವಿಷ್ಯವಾಣಿಗಳ ಸಮಯಸೂಚಿ",
    "planetary_remedies_guidance": "ಗ್ರಹ ಪರಿಹಾರಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "career_finance_predictions": "ವೃತ್ತಿ ಮತ್ತು ಹಣಕಾಸು ಭವಿಷ್ಯವಾಣಿಗಳು",

    // Visual Content
    "sample_dasha_phal": "ಮಾದರಿ ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ",
    "sample_dasha_phal_description": "ನಿಮ್ಮ ವಿಸ್ತೃತ ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ ಹೇಗೆ ಕಾಣುತ್ತದೆ",
    "major_planetary_periods": "ಪ್ರಮುಖ ಗ್ರಹ ಅವಧಿಗಳು",

    // Planetary Periods
    "sun_dasha": "ಸೂರ್ಯ ದಶೆ",
    "moon_dasha": "ಚಂದ್ರ ದಶೆ", 
    "mars_dasha": "ಮಂಗಳ ದಶೆ",
    "mercury_dasha": "ಬುಧ ದಶೆ",
    "jupiter_dasha": "ಗುರು ದಶೆ",
    "venus_dasha": "ಶುಕ್ರ ದಶೆ",

    // Status & Processing
    "your_dasha_phal_analysis_status": "ನಿಮ್ಮ ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಸಂಸ್ಕರಿಸುತ್ತಿದ್ದೇವೆ",
    "analysis_processing_message": "ನಮ್ಮ ಪರಿಣಿತ ಜ್ಯೋತಿಷಿಗಳು ನಿಮ್ಮ ಜನ್ಮ ಕುಂಡಲಿ ಮತ್ತು ಗ್ರಹ ಅವಧಿಗಳನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿನಂತಿ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "pending": "ಬಾಕಿ ಇದೆ",
    "email_notification_sent": "ಇಮೇಲ್ ಅಧಿಸೂಚನೆ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್ ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತದೆ",
    "delivery_within_12_hours": "೧೨ ಗಂಟೆಗಳೊಳಗೆ ವಿತರಣೆ",

    // Support & Contact
    "contact_support": "ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಸಹಾಯ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Form Validation Messages
    "name_required": "ಹೆಸರು ಅಗತ್ಯವಿದೆ",
    "email_required": "ಇಮೇಲ್ ಅಗತ್ಯವಿದೆ",
    "phone_required": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ",
    "date_required": "ಜನ್ಮ ದಿನಾಂಕ ಅಗತ್ಯವಿದೆ",
    "time_required": "ಜನ್ಮ ಸಮಯ ಅಗತ್ಯವಿದೆ",
    "place_required": "ಜನ್ಮ ಸ್ಥಳ ಅಗತ್ಯವಿದೆ"
}
 